<mat-toolbar class="toolbar-container">
  <mat-toolbar-row *ngIf="outOfBounds$ | async">
    <q9-primary-button
      [matTooltip]="'TOOLBAR.BACK_TO_TASKS_TOOLTIP' | translate"
      (click)="navBackToLastTrainingItem()">
      {{ 'TOOLBAR.BACK_TO_TASKS' | translate }}
    </q9-primary-button>
  </mat-toolbar-row>
  <div [style.display]="!(outOfBounds$ | async) && (enabled$ | async) ? 'block' : 'none'">
    <mat-toolbar-row>
      <div class="actions-container">
        <div class="tasks-container">
          <q9-icon-button
            #navigationPrev
            [icon]="'arrow_left-icon'"
            [disabled]="!hasPrev"
            [matTooltip]="'TOOLBAR.AUTHORISATION_PREVIOUS_TASK' | translate"
            (click)="navigationPrev.disabled ? null : navPrev()"></q9-icon-button>
          <button
            class="training-nav-menu-btn"
            [matMenuTriggerFor]="trainingItems"
            [matTooltip]="'TOOLBAR.AUTHORISATION_TASK_LIST' | translate">
            <div class="training-nav-label tasks-section">
              <div>
                {{ 'TOOLBAR.TRAINING_TASK_LABEL' | translate }}
                {{ currentPosition$ | async }}/{{ (navArray$ | async)?.length }}
              </div>
              <div class="mat-select-arrow-wrapper">
                <div class="mat-select-arrow"></div>
              </div>
            </div>
          </button>
          <mat-menu #trainingItems="matMenu" class="training-nav-trainings-menu">
            <div *ngFor="let task of navArray$ | async">
              <button
                class="training-nav-menu-item"
                mat-menu-item
                [ngClass]="{
                  'training-nav-menu-item--current':
                    (current$ | async)?.item?.diagramId === task.item.diagramId
                }"
                (click)="processNavigation(task.item.diagramId)">
                <mat-checkbox
                  class="q9-checkbox training-nav-menu-item__checkbox"
                  color="primary"
                  [disableRipple]="true"
                  [checked]="['seen', 'done'].includes(task.status)"></mat-checkbox>
                <div class="training-nav-menu-item-label">
                  <div class="item-main-label">
                    <span>{{ task.item.name | htmlEncoder: true }}</span>
                  </div>
                  <div class="item-secondary-label">
                    <span>
                      {{ 'TOOLBAR.TRAINING_MENU_LEVEL_LABEL' | translate }}
                      {{ task.item.levelNumber }} {{ task.item.map.name | htmlEncoder: true }}
                    </span>
                  </div>
                </div>
              </button>
              <mat-divider></mat-divider>
            </div>
          </mat-menu>
          <q9-icon-button
            #navigationNext
            [icon]="'arrow_right-icon'"
            [disabled]="!hasNext"
            [matTooltip]="'TOOLBAR.AUTHORISATION_NEXT_TASK' | translate"
            (click)="navigationNext.disabled ? null : navNext()"></q9-icon-button>
        </div>
        <q9-icon-button
          [icon]="'information-icon'"
          [matTooltip]="'TOOLBAR.CLICK_FOR_INFO_BTN' | translate"
          [matMenuTriggerFor]="trainingInfo"></q9-icon-button>
        <mat-menu #trainingInfo="matMenu" class="training-nav-trainings-menu">
          <app-training-popup
            [diagramHistory]="diagramHistory$ | async"
            [config]="(tooltip$ | async)?.tooltip"></app-training-popup>
        </mat-menu>
        <q9-icon-button
          [icon]="'close-icon'"
          [matTooltip]="'TOOLBAR.EXIT_TRAININGS_MODE' | translate"
          (click)="closeTask()"></q9-icon-button>
      </div>
    </mat-toolbar-row>
    <mat-divider></mat-divider>
    <mat-toolbar-row>
      <q9-secondary-button
        *ngIf="taskStatusChecked$ | async as status"
        [q9Track]="
          status.isCompleted || status.isChecked
            ? 'TRAINING_CANCEL_ACKNOWLEDGE'
            : 'TRAINING_ACKNOWLEDGE'
        "
        [disabled]="status.isCompleted"
        [matTooltip]="
          (status.isCompleted || status.isChecked
            ? 'TOOLBAR.TRAINING_COMPLETED'
            : 'TOOLBAR.COMPLETE_TRAINING'
          ) | translate
        "
        [matTooltipDisabled]="status.isCompleted || status.isChecked"
        (click)="markDiagram({checked: !(status.isCompleted || status.isChecked)})">
        {{
          (status.isCompleted || status.isChecked
            ? 'TOOLBAR.CANCEL_CONFIRMATION'
            : 'TOOLBAR.UNDERSTAND_NEW_PROCESS'
          ) | translate
        }}
      </q9-secondary-button>
    </mat-toolbar-row>
  </div>
</mat-toolbar>
